import React from 'react'
import Zmage from 'react-zmage'
import 'video-react/dist/video-react.css'
import { Modal } from 'antd'
import ZoomImg from 'react-zoomimg'
import {
    CloseOutlined
} from '@ant-design/icons';

import styles from './img.module.scss'


import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import upImg from '@/files/modal/imglist/zoomAdd.png'
import downImg from '@/files/modal/imglist/zoomReduce.png'

import classnames from 'classnames'

/**
 * video-react 配置文档：https://video-react.js.org/components/player/
 */
export default class Img extends React.PureComponent {
  ref = React.createRef()

  state = {
    imgLable: 0
  }

  handleClose = () => {
    this.props.onClose && this.props.onClose()
    this.setState({
      imgLable: 0
    })
  }

  componentDidUpdate(prevProps) {
    const { show, src } = this.props
    const prevSrc = prevProps.videoSrc

    // if (!show) {
    //   console.log("componentDidUpdate pause")
    //   this.ref.current.pause()
    // } else if (prevSrc !== src) {
    //   this.ref.current.load()
    //   console.log("componentDidUpdate load")
    // } else {
    //   this.ref.current.play()
    //   console.log("componentDidUpdate play")
    // }
  }

  render() {
    const { show, src, language , imgSizes} = this.props
    const { imgLable } = this.state
    const imgClasses = classnames([
      styles.img,
    //   imgLable===0?styles.img0:null,
    //   imgLable===1?styles.img1:null,
    //   imgLable===2?styles.img2:null,
    //   imgLable===3?styles.img3:null,
    //   imgLable===4?styles.img4:null,
    //   imgLable===5?styles.img5:null,
    //   imgLable===6?styles.img6:null,
    //   imgLable===7?styles.img7:null,
    //   imgLable===8?styles.img8:null,
    ])
      const imgStyle = {
        width: imgSizes[imgLable]+'vw'
      }
    return (
        <Modal
          id="videoModal"
          visible={show}
          className={styles.imgmodal}
          // wrapClassName={styles.cont}
          footer={null}
          onCancel={this.handleClose}
          closable={false}
          maskStyle={{
            background: 'none',
          }}
        >
          <div className={styles.imgDiv}>
              {/* 关闭按钮 */}
              <CloseOutlined className={styles.closeBtn} onClick={this.handleClose}/>
          {/* 图片本体 */}
              {src ? <img
              className={imgClasses}
              // style={imgStyle}
              style={imgStyle}
              src={src}
            /> : null}

          {/* 滑动装置 */}
            <div  className={styles.sliderDiv}>
              <img
                className={styles.sliderIcon}
                src={upImg}
                onClick={() => {
                  let imgLableNew = this.state.imgLable
                  if(imgLableNew < 3) imgLableNew++
                  this.setState({
                    imgLable: imgLableNew
                  })
                }}
               />
              <Slider
              className={styles.slider}
              vertical
              step={35}
              included={false}
              value={this.state.imgLable*35}
              onChange={(e) => {
                this.setState({
                  imgLable: Math.ceil(e/35)
                })
              }}
              />
              <img
                className={styles.sliderIcon}
                src={downImg}
                onClick={() => {
                  let imgLableNew = this.state.imgLable
                  if(imgLableNew > 0) imgLableNew--
                  this.setState({
                    imgLable: imgLableNew
                  })
                }}
                 />
            </div>
          </div>
        </Modal>
    )
  }
}
